import moment from 'moment';
import { formatInLanguage, getMomentLocale } from './moment-locales';

/**
 * FE#535 — DISPLAY-ONLY 12h/24h clock. Changes how a time is shown and typed; never the
 * HH:mm value a picker emits, the stored dueDate, time zones or send timing.
 *
 * Master switch. While false every helper below returns exactly what the app computed
 * before this feature, whatever the saved preference says. On since #423.
 */
export const TIME_FORMAT_24H_ENABLED = true;

export type ClockPreference = '12h' | '24h';

export const toClockPreference = (value: unknown): ClockPreference | undefined =>
  value === '12h' || value === '24h' ? value : undefined;

/** The interface language's own default: does its short time (`LT`) carry an am/pm? */
export const localeUses12h = (language: string | null | undefined): boolean =>
  /a/i.test(moment.localeData(getMomentLocale(language)).longDateFormat('LT'));

/** Saved preference wins when the flag is on; unset or flag off = the locale default. */
export const resolveUses12h = (
  language: string | null | undefined,
  preference?: ClockPreference,
  enabled: boolean = TIME_FORMAT_24H_ENABLED,
): boolean => (enabled && preference ? preference === '12h' : localeUses12h(language));

/** A clock label ("9:45 PM" / "21:45"). Unset/disabled keeps the locale's own `LT`. */
export const formatClockTime = (
  value: moment.MomentInput,
  language: string | null | undefined,
  preference?: ClockPreference,
  enabled: boolean = TIME_FORMAT_24H_ENABLED,
): string => {
  if (!enabled || !preference) return formatInLanguage(value, language, 'LT');
  return formatInLanguage(value, language, preference === '12h' ? 'h:mm A' : 'HH:mm');
};
